






































import { Component, Vue } from 'vue-property-decorator';
import { ICart } from '@/models/CartModels';
import VueBase from '@/VueBase.vue';

@Component({
  created() {
    this.$store.dispatch('carts/setViewedCartId', this.$route.params.id);
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.dispatch('carts/setViewedCartId', to.params.id);
    next();
  },
})
export default class ViewCart extends VueBase {
  public title = '';

  public get cart(): ICart | undefined {
    return this.cartState.carts.find(
      (cart) => cart.title === this.cartState.viewedCartId,
    );
  }

  public addItem() {
    if (this.title !== '') {
      this.$store.dispatch('carts/addItem', {
        cart: this.cart,
        item: { title: this.title, amount: 1 },
      });
    }

    this.title = '';
  }

  public deleteSelected() {
    this.$store.dispatch('carts/deleteSelected', {
      cart: this.cart,
    });
  }
}
